import Vue from "vue";
import { mapGetters } from "vuex";

import buttonIncluirComponent from "@/components/child/form/button/buttonIncluir.vue";
import cepFieldComponent from "@/components/child/form/cepfield.vue";
import checkboxComponent from "@/components/child/form/checkbox.vue";
import comboComponent from "@/components/child/form/combo.vue";
import fieldsetComponent from "@/components/child/form/fieldset.vue";
import { Component, Prop, Watch } from "@/decorators";
import CepModel from "@/models/cepModel";
import ClienteEnderecoEntregaModel from "@/models/clienteEnderecoEntregaModel";
import ClienteModel from "@/models/clienteModel";
import EnumExtensions from "@/models/enum/extensions/enumExtensions";
import TiposPessoa from "@/models/enum/tiposPessoa";
import Ufs from "@/models/enum/ufs";
import FranquiaModel from "@/models/franquiaModel";
import CidadeService from "@/services/external/cidadeService";
import { Getters } from "@/store/store";

@Component({
    components: {
        comboComponent,
        cepFieldComponent,
        checkboxComponent,
        buttonIncluirComponent,
        fieldsetComponent,
    },
    computed: {
        ...mapGetters(["GET_FRANQUIA_ATUAL", "GET_IS_ESTEREIS", "GET_IS_FRACIONAMENTO"] as Getters),
    },
})
export default class enderecoEntregaEditComponent extends Vue {
    GET_FRANQUIA_ATUAL!: () => FranquiaModel;
    GET_IS_ESTEREIS!: () => Promise<boolean>;
    GET_IS_FRACIONAMENTO!: () => Promise<boolean>;

    private cidadeService = new CidadeService();

    isEstereis = false;

    model = new ClienteEnderecoEntregaModel();
    dadosCep = new CepModel();

    private editingModel = false;

    cidadesEntregaOptions: Array<{ value: number; text: string }> = [];
    ufOptions: Array<Object> = EnumExtensions.getNamesAndValuesOrderedByNames(Ufs);

    tiposPessoaEntregaOptions: Array<Object> = [
        { text: "Física", value: TiposPessoa.Fisica },
        { text: "Jurídica", value: TiposPessoa.Juridica },
    ];

    @Prop({ type: Number, default: null }) clienteId!: number;

    private async mounted() {
        this.isEstereis = await this.GET_IS_ESTEREIS();
    }

    public async load(model: ClienteEnderecoEntregaModel) {
        this.clear();
        this.model = model;
        this.cidadesEntregaOptions.push({ value: model.cidadeId ?? 0, text: model.cidade });

        const cidadeEncontrada = this.cidadesEntregaOptions.find(item => item["value"] == this.model.cidadeId);
        this.model.cidade = cidadeEncontrada ? cidadeEncontrada?.["text"] : "";
        this.editingModel = true;
    }

    public clear() {
        this.dadosCep = new CepModel();
        this.model = new ClienteEnderecoEntregaModel();
        this.model.clienteId = this.clienteId;

        this.editingModel = false;
    }

    public replicar(model: ClienteModel) {
        this.model.cep = model.cep;
        this.model.estadoId = model.estadoId;
        this.model.cidadeId = model.cidadeId;
        this.model.cidade = model.cidade;
        this.model.bairro = model.bairro;
        this.model.endereco = model.endereco;
        this.model.complemento = model.complemento;
        this.model.numero = model.numero;
    }

    private async onAdicionarItem() {
        if (!(await this.$validator.validateAll())) {
            return;
        }

        if (this.editingModel) {
            this.$emit("edicao-endereco", this.model);
        } else {
            this.$emit("inclusao-endereco", this.model);
        }
    }

    private onCancelar() {
        this.clear();
    }

    private onCepInvalid() {
        this.$showInfo(this.$t("__.ts.pesqCEP"), this.$t("__.ts.pesqNaoEncResul"));
    }

    private onCepChanged(data: CepModel) {
        this.dadosCep = data;
        this.model.bairro = data.bairro;
        this.model.estadoId = data.uf;
        this.model.cidadeId = data.cidadeId;
        this.model.cidade = data.cidadeNome;
        this.model.complemento = data.complemento;
        this.model.endereco = data.endereco;
    }

    //@ts-ignore
    @Watch("model.estadoId")
    private async onEstadoChange() {
        try {
            if (this.model.estadoId) {
                const data = await this.cidadeService.get(this.model.estadoId).withLoading();
                this.cidadesEntregaOptions = data;

                if (this.dadosCep.cidadeId) {
                    this.model.cidadeId = this.dadosCep.cidadeId;
                }

                const cidadeEncontrada = this.cidadesEntregaOptions.find(item => item["value"] == this.model.cidadeId);
                this.model.cidade = cidadeEncontrada ? cidadeEncontrada?.["text"] : "";
            }
        } catch {}
    }
}
